<!--
	HamburgerMenu.svelte
-->

<script>
    import { onMount } from 'svelte';
    import { push } from 'svelte-spa-router';
    import { signOut, signIn, hasSessionRoles } from '../../common/auth.js';
    import { ROLE_REVIEW_WRITE } from '../../common/roles-actions.js';

    // TCARE components
    //import { ROUTE_HOME, ROUTE_SEARCH, ROUTE_TASKS, ROUTE_TESTS } from '../../common/routes.js';

    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiMenu } from '@mdi/js';
	import { mdiHome, mdiMagnify, mdiDatabase, mdiPlusBox, mdiMapMarker } from '@mdi/js';
	import { mdiCharity } from '@mdi/js';
	import { mdiCardAccountDetailsOutline, mdiLogout } from '@mdi/js';
    

    // SMUI example code
    import Menu from '@smui/menu';
    import List, { Item, Separator } from '@smui/list';
    import { AccountStore } from "../../common/account";

    export let user;

    $: isMenuShowing = false;
    $: user = $AccountStore

    onMount(() => {
        // console.log('');
        // console.log('HamburgerMenu onMount');
        // console.log('$AccountStore');
        // console.log($AccountStore);
        // console.log('');        
    })

	const onMenuClick = () => {
        isMenuShowing = true;
	}

    // dashboard
	const onHomeClick = () => {
        isMenuShowing = false;
        if (!$AccountStore.isLoggedIn) return;      // should be disabled
        push('/home');
	}

    const onSearchClick = () => {
        isMenuShowing = false;
        if (!user) return;
        push('/search');
	}

	const onReviewsClick = () => {
        isMenuShowing = false;
        if (!user) return;
        push('/reviews');
	}

	const onCreateServiceClick = () => {
        isMenuShowing = false;
        if (!user) return;
        push('/create_service');
	}

    const onExplorerClick = () => {
        isMenuShowing = false;
        if (!user) return;
        push('/explorer');
	}

	const onMyResourcesClick = () => {
        isMenuShowing = false;
        if (!user) return;
        push('/my-resources');
	}

    // auth.js functions

	const onLogoutClick = () => {
        isMenuShowing = false;
        if (!user) return;
        signOut();
	}

</script>


<style>
    .menu-icon {
        width: 36px;
        height: 36px;
    }

	* :global(.menu-icon svg) {
		width: 36px !important;
		height: 36px !important;
		fill: var(--tcare-white);
		outline: none;
	}

    * :global(.menu-icon svg):hover {
        fill: var(--tcare-secondary);
    }

    * :global(.icon-disabled svg) {
        fill: var(--tcare-disabled) !important;
    }

    :global(.menu-list) {
        z-index: 999;
        min-width: 240px;
        background-color: var(--tcare-white);
    }

    .menu-list-icon {
        width: 26px;
        height: 26px;
        margin-right: 10px;
    }

	* :global(.menu-list-icon svg) {
		fill: var(--tcare-primary);
	}


    @media screen and (max-width: 600px) {
        .menu-icon {
            width: 36px;
            height: 36px;
        }
        * :global(.menu-icon svg) {
            width: 30px !important;
            height: 30px !important;
        }
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="hamburger-menu">
    <div class="menu-icon flex-center" on:click={onMenuClick}>
        <Icon component={Svg} viewBox="0 0 24 24" >
            <path d={mdiMenu} />
        </Icon>	
    </div>


    <Menu bind:open={isMenuShowing}>
        <List class="menu-list">
            {#if user}
                {#if user.roles.length > 0}
                    <Item on:click={onHomeClick}>
                        <div class="menu-list-icon">
                            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiHome} /></Icon>
                        </div>        
                        <div class="menu-list-text primary fs-1">Dashboard</div>
                    </Item>

                    <Item on:click={onSearchClick}>
                        <div class="menu-list-icon">
                            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiMagnify} /></Icon>
                        </div>        
                        <div class="menu-list-text primary fs-1">Search</div>
                    </Item>

                    {#if hasSessionRoles([ROLE_REVIEW_WRITE])}
                        <Item on:click={onReviewsClick}>
                            <div class="menu-list-icon">
                                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiDatabase} /></Icon>
                            </div>        
                            <div class="menu-list-text primary fs-1">Reviews</div>
                        </Item>
                    {/if}

                    <Item on:click={onCreateServiceClick}>
                        <div class="menu-list-icon">
                            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiPlusBox} /></Icon>
                        </div>        
                        <div class="menu-list-text primary fs-1">Create Service</div>
                    </Item>

                    <Separator />

                {/if}

                <!-- the menu items below show for all users even if no roles -->

                <Item on:click={onExplorerClick}>
                    <div class="menu-list-icon">
                        <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiCardAccountDetailsOutline} /></Icon>
                    </div>        
                    <div class="menu-list-text primary fs-1">Resource Explorer</div>
                </Item>
    
                <Item on:click={onMyResourcesClick}>
                    <div class="menu-list-icon">
                        <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiCharity} /></Icon>
                    </div>        
                    <div class="menu-list-text primary fs-1">My Resources</div>
                </Item>
    
                <Separator />

                <Item on:click={onLogoutClick}>
                    <div class="menu-list-icon">
                        <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiLogout} /></Icon>
                    </div>        
                    <div class="menu-list-text primary fs-1">Log Out</div>
                </Item>

            {/if}
        </List>
    </Menu>

</div>
    
